<!--  Mock interview-->
<template>
  <div class="mentee-mock">
    <div class="mentee-mock-item">
      <div class="mentee-mock-item-title">
        <zlr-title title="Appointment - In progress"
                   :depth=65></zlr-title>
      </div>
      <ul class="mentee-mock-item-list"
          v-if="unfinishList.length>0">
        <li v-for="(item, index) in unfinishList"
            :key="index">
          <zlr-appointment-list name="Mock interview"
                                :prompt="item.statu|todoStatusTitleMap"
                                :color="item.statu|todoStatusColorMap"
                                @click="linkHandle(item)"></zlr-appointment-list>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
    </div>
    <div class="mentee-mock-item">
      <div class="mentee-mock-item-title">
        <zlr-title title="Appointment - Complete"
                   :depth=65></zlr-title>
      </div>
      <ul class="mentee-mock-item-list"
          v-if="finishList.length>0">
        <li v-for="(item, index) in finishList"
            :key="index">
          <zlr-appointment-list name="Mock interview"
                                :prompt="item.statu|todoStatusTitleMap"
                                :color="(item.statu !== 'SYSTEM_RECALL' && item.statu !== 'RECALL')?'blue':'gray'"></zlr-appointment-list>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
    </div>
  </div>
</template>

<script>
// api
import { getAppInterviewUnfinishList, getAppInterviewFinishList } from '@/api/appointment'
// components
import ZlrTitle from '_c/title/title'
import ZlrAppointmentList from '_c/appointment-list/appointment-list'
import ZlrEmpty from '_c/empty/empty'
export default {
  name: 'mentee-mock-interview',
  components: {
    ZlrTitle,
    ZlrAppointmentList,
    ZlrEmpty
  },
  data () {
    return {
      programId: this.$route.params.programId,
      unfinishList: [],
      finishList: []
    }
  },
  computed: {},
  mounted () {
    this.getUnfinishList()
    this.getFinishList()
  },
  methods: {
    // 获取未完成的
    getUnfinishList () {
      getAppInterviewUnfinishList({
        projectId: this.programId
      }).then(res => {
        this.unfinishList = res.data.model
      })
    },
    //  获取已完成
    getFinishList () {
      getAppInterviewFinishList({
        projectId: this.programId
      }).then(res => {
        this.finishList = res.data.model
      })
    },
    linkHandle ({ id }) {
      this.$router.push({
        name: 'mentee-mock-zoom',
        query: {
          id
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
